import { ContentAudioData } from './PresentContentAudio';
import { FC, useCallback, useState } from 'react';
import { SessionContainerProps, config } from '../config';
import { logAmplitude } from '../../../utils/analytics/analytics';
import { observer } from 'mobx-react';
import { useOnMount } from '../../../hooks/useOnMount';
import { useStores } from '../../../hooks/useStores';


const _ContainContentAudio: FC<SessionContainerProps<ContentAudioData>> = ({
  onNext,
  onFinish,
  children,
}) => {
  const [durationMillis, setPositionMillis] = useState(0);
  const [durationPercent, setPositionPercent] = useState(0);
  const rootStore = useStores();
  const contentId = rootStore.treeNav.content.sessionStep?.contentId;
  const track = contentId
    ? rootStore.content.getTracks([contentId])[0]
    : undefined;
  useOnMount(() => {
    logAmplitude('Activity Started', {
      contentType: 'audio',
      activityId: track?.humanReadableId || track?._id,
      activityType: track?.activityType,
      from: inPath ? 'path' : 'library',
    });
  });
  const pathId = rootStore.treeNav.content.session?.path;
  const sessionStepId = rootStore.treeNav.content.sessionStep?.ownId;
  const inPath = !!pathId;
  const labels = rootStore?.language.translate.MOBILE?.STEP_AUDIO;
  const endOfMediaAnalytics = useCallback(() => {
    // TODO this event should also be emitted onPrevious and onExit (ActionBar)
    // this could be implemented using event emitters, which would avoid prop drilling and awkward if-statements
    // for triggering under the right conditions. the event listener can subscribe and unsubscribe right here.
    logAmplitude('Media Ended', {
      contentType: 'CONTENT_AUDIO' as keyof typeof config,
      contentId,
      contentName: track?.title,
      position: durationMillis,
      percentageReading: durationPercent
    });
    logAmplitude('Activity Finished', {
      contentType: 'audio',
      activityId: track?.humanReadableId || track?._id,
    });
  }, [contentId, durationMillis, durationPercent, track?._id, track?.humanReadableId, track?.title]);
  const onNextSendAnalytics = useCallback(() => {
    endOfMediaAnalytics();
    onNext?.();
  }, [endOfMediaAnalytics, onNext]);
  return children({
    onNext: onNextSendAnalytics,
    onFinish,
    data: {
      track,
      inPath,
      sessionStepId,
      setPositionMillis,
      setPositionPercent,
    },
    labels,
  });
};

export const ContainContentAudio = observer(_ContainContentAudio);

